import React,{useState} from "react";
import { graphql, Link } from "gatsby"
import { navigate } from "@reach/router"
import isbot from 'isbot'
import axios from 'axios';

import 'bootstrap/scss/bootstrap.scss'
import $ from 'jquery';
import "../scss/global.scss";
import "../scss/search-result.scss";
import Filter from "../components/FilterBox/FilterBox"
import PropertyInfo from "../components/PropertyInfo/PropertyInfo";
import SalesCard from "../components/SalesCard/SalesCard";
import Layout from "../components/Layout"
import Journey from "../components/Journey/Journey";
import SeoResult from "../common/seoResult"

import algoliasearch from 'algoliasearch/lite';
import { propertyIntro, propertySearchParams, Sortindex} from "../common/utils/property_utils";
import { sortByList, leadooPageSlot, Default_View, defaultArea_Slug } from "../common/constant";

import { ApiRequest } from "../common/utils/api_request_utils";
import { toCapitalize} from "../common/utils/site_utlis";
import Loadable from "@loadable/component"

const MapResultsDesktop = Loadable(() => import("../components/map/search-results-desktop-map"));
const MapResultsMobile = Loadable(() => import("../components/map/search-results-mobile-map"));

//const { parseResultsUrl, generateFiltersfromPageData } = require("@starberry/gatsby-library-common/PropertySearchNew")

//const key_path_name = typeof window !== 'undefined' ?  window.location.href : ''

const { parseResultsUrl, generateFiltersfromPageData } =  require("../common/gatsby-library-common/PropertySearchNew")

class SearchResultTemplate extends React.Component {
    isUserInteraction = true;
    constructor(props) {
        super(props);
    }
    
    /* ========= Local Cache =========== */
    local_storage_data = typeof window !== 'undefined' &&  localStorage.getItem('algolia_data') ? JSON.parse(localStorage.getItem('algolia_data')) : [];


    state = {
        //searchState: urlToSearchState(index_name, typeof window !== 'undefined' ? window.location : ''),
        algoliadata: [],
        my_page_url_data: [],
        chkalgolia: true,
        isGridView: Default_View === "List" ? false : true,
        noResultProperties: [],
        includes: false,
        scroll: false,
        width: 0, height: 0,
        status: this.props.status,
        office_crm_id: this.props?.location?.state?.office_crm_id,
        show_pppw: true,
        include_bills: false,

        local_cache: this.local_storage_data  // ========= Local Cache ===========    
    }

    componentWillMount() {
        let pathname = this.props.location?.pathname
        var default_area_path = "in-" + defaultArea_Slug.toLowerCase() + "/";
        if(pathname === this.props.path){
            navigate(this.props.path+default_area_path)
        }

        if(typeof window !== 'undefined'){
            this.setState({ 
                width: window.innerWidth, 
                height: window.innerHeight 
            }, () => 
                this.state.width > 1200 ? this.setState({isGridView: Default_View === "List" ? false : true}) : this.setState({isGridView:false})
            );
        }

        //console.log("key_path_name", key_path_name)
    }

    componentDidMount() {
        window.addEventListener('popstate', this.onPopState);

        this.checkGoogleBot();     

        $(document).mouseup(function (e) {

            var containerdiv = $(".search-field, .filter-box, .filter_toggle");

            // if the target of the click isn't the container nor a descendant of the container
            if (!containerdiv.is(e.target) && containerdiv.has(e.target).length === 0) {
                $(".search-field").removeClass("actv_cls");
            }
        });

    }

    componentWillUnmount() {
        //clearTimeout(this.debouncedSetState);
        window.removeEventListener('popstate', this.onPopState);
    }

    onPopState = ({ state }) => {
        this.setState({
            searchState: state || {},
        });
    }

    componentDidUpdate(prevProps) {

        console.log("location ==>", prevProps.location !== this.props.location, prevProps.location, this.props.location)

        if (prevProps.location !== this.props.location) {

            //console.log("location ==>", prevProps.location, this.props.location)

            //this.setState({ searchState: urlToSearchState(index_name, this.props.location) })
            this.isUserInteraction = true;
            this.checkGoogleBot();
            
        }
    };


    onViewChange = (val) => {
        this.setState({ isGridView: val })
    }

    showPPPW = (event) => {
        this.setState({ show_pppw: event.target.checked ? true : false }) 
    }

    includeBills = (event) => {
        this.setState({ include_bills: event.target.checked ? true : false }) 
    }

    onSaleAgreed = (event) => {
        this.setState({ status: event.target.checked ? [event.target.value] : this.props.status }) 
    }

    checkGoogleBot = () =>{
        let realuser = true
        if (typeof window !== 'undefined') {
            let bot_request = process.env.GATSBY_BlOCK_ALGOLIA_BOT_REQUEST || process.env.GATSBY_BLOCK_ALGOLIA_BOT_REQUEST;

            realuser = (bot_request === "true") ? (isbot(navigator.userAgent) ||  navigator.userAgent.indexOf("Prerender") > -1) : false
        }
        console.log("realuser ==>", realuser)

        if(realuser === false){
            this.getAlgoliaResults();
        } else{
            this.getBotSearchResult();
        }
    }

    getBotSearchResult = async() => {
        const page_url_data = parseResultsUrl(this.props.location)
        this.setState({ my_page_url_data: page_url_data })

        let $where = `_where[publish]=true&[department]=${page_url_data['departmentVal']}&[search_type]=${page_url_data['searchtypeVal']}`

        let status_arr = this?.state?.status;
        if(Array.isArray(this?.state?.status)){
            if(status_arr.length > 0){
                status_arr.map((status, ind) => {
                    $where +=`&[_or][${ind}][status_contains]=${status}`
                })
            }
        } else{
            $where +=`&[status_contains]=${this?.state?.status}`
        }

        let sorting = `sort_date:DESC,status:ASC`;

        let area_name = page_url_data['areaVal'];
        console.log("area_name", area_name)
        if(area_name === defaultArea_Slug.replace(/-/g,' ')){
            $where +="";
        } else{
            $where +=`&[display_address_contains]=${area_name}`
        }

        if(page_url_data['buildingval']){
            $where += `&[building_contains]=${page_url_data['buildingval']}`;
        }
        if(page_url_data['bedVal']){
            $where += `&[bedroom_gte]=${page_url_data['bedVal']}`;
            sorting = `bedroom:ASC,sort_date:DESC,status:ASC`;
        }
        if(page_url_data['bedVal'] === 0){
            $where += `&[bedroom_lte]=${page_url_data['bedVal']}`;
            sorting = `bedroom:ASC,sort_date:DESC,status:ASC`;
        }

        const auth_headers = { Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`}
        const property_api_link = `${process.env.GATSBY_STRAPI_SRC}/properties`

        let count_properties = await axios.get(`${property_api_link}/count?_sort=${sorting}&${$where}`,{headers: auth_headers})

        //console.log("count_properties", count_properties, count_properties?.data)

        axios.get(`${property_api_link}?_limit=20&_sort=${sorting}&${$where}`, {headers: auth_headers}).then(res => {
            //console.log("res =>1", res)
            if(res.status === 200){
                //getAlgoliadata({hits:res.data})
                if(count_properties?.data > 0){
                    this.setState({
                        algoliadata: {hits:res.data, total: count_properties?.data, realuser: true}
                    })
                } else{
                    this.getAlgoliaResults();
                }

            } else{
                this.getAlgoliaResults();
            }

            this.isUserInteraction = false;
            this.forceUpdate();
        })

    }
    
    
    getAlgoliaResults = () => {
        const page_url_data = parseResultsUrl(this.props.location)
        this.setState({ my_page_url_data: page_url_data })

        let myalgoliafilters = generateFiltersfromPageData(page_url_data['departmentVal'], page_url_data['searchtypeVal'], page_url_data['areaVal'], page_url_data['bedVal'],page_url_data['bedValPlus'], page_url_data['minpriceVal'], page_url_data['maxpriceVal'], page_url_data['buildingval'], page_url_data['mustincludeVal'], page_url_data['furnishVal'], page_url_data['branchVal'])

        let mystatus = ''
        if(Array.isArray(this?.state?.status)){
            mystatus = '(status:"'+(this.state.status).join('" OR status:"')+'")'
        } else {
            mystatus = '(status:"'+(this.state.status)+'")'
        }
        myalgoliafilters += ' AND '+mystatus

        if(this.props?.location?.state?.prestige_property === true){
            myalgoliafilters += ' AND (officeDepartment:Prestige)'
        }
        if(this.props?.location?.state?.collections_property === true || this.props?.collections_property === true){
            myalgoliafilters += ' AND (officeDepartment:Collection)'
        }
        if(this.props?.location?.state?.student_property === true || this.props?.student_property === true){
            myalgoliafilters += ' AND (officeDepartment:Student)'
        }

        if(this.props?.location?.state?.new_homes === true){
            myalgoliafilters += ' AND (officeDepartment:"New Homes" OR officeDepartment:"NEW")'
        }

        if(this.props?.location?.state?.holiday_homes === true){
            myalgoliafilters += ' AND (officeDepartment:"BPH")'
        }

        // if(this.state?.show_pppw === true){
        //     myalgoliafilters += ' AND (show_pppw:true)'
        // }

        // if(this.state?.include_bills === true){
        //     myalgoliafilters += ' AND (include_bills:true)'
        // }


        if(this.props?.location?.state?.office_crm_id){
            var split_branch = this.props?.location?.state?.office_crm_id.split(',');

            if(Array.isArray(split_branch)){
                myalgoliafilters += 'AND (office_crm_id:"'+(split_branch).join('" OR office_crm_id:"')+'")'
            } else {
                myalgoliafilters += 'AND (office_crm_id:"'+(this.props?.location?.state?.office_crm_id)+'")'
            }
        }
        //myalgoliafilters += ' AND (publish:true)'
        //console.log("prestige_property",this.props?.location?.state)

        const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_API_KEY);
        const index = client.initIndex(page_url_data['sortVal'] ? page_url_data['sortVal'] : page_url_data['indexVal']);

        /* ========= Local Cache =========== */
        let path_name = typeof window !== 'undefined' ? window.location.href : ''
        var expTime = new Date().setMinutes(new Date().getMinutes() + 5);
        let filter_local_cache = this.filterLocalCache(path_name);

        let hits_per_page = this.state.width > 1200 ? 20 : (this.state.isGridView ? 2000 : 20)

        //console.log("filter_local_cache", filter_local_cache[0][path_name].filter_data)
        
        if(filter_local_cache?.length > 0 && myalgoliafilters === filter_local_cache[0][path_name].filter_data){
            //console.log("algoliadata 1", filter_local_cache)
            let get_data = filter_local_cache[0];
            let get_data_pathname = get_data[path_name]
            //console.log("get_data ==>", get_data_pathname);

            if(get_data_pathname?.total > 0){
                this.setState({
                    algoliadata: get_data_pathname
                })
            } else{
                this.setState({ algoliadata: [] })

                // setTimeout(() => {
                //     window.scrollTo(0, 0)
                // }, 1000)
                this.getNoResultProperties();
                
            }
            
        } else{
            if (this.isUserInteraction) {
                let area_val = '"'+page_url_data['areaVal']+'"'
                index.search((page_url_data['areaVal'] === (process.env.GATSBY_DEFAULT_AREA).toLowerCase() ? '' : area_val), {
                    filters: myalgoliafilters,
                    page: (page_url_data['pageVal'] - 1),
                    hitsPerPage: 20
                }).then(({ nbHits, page, hitsPerPage, nbPages, hits }) => {
                    //console.log("hits ==>", hits, nbHits)
                    
                    /* ========= Local Cache expTime =========== */
                    let myArray = { "total": nbHits, "current_page_number": page, "hitsPerPage": hitsPerPage, "number_of_pages": nbPages, "hits": hits, expTime: expTime, filter_data: myalgoliafilters };
                    
                    if(nbHits > 0){
                        this.setState({ algoliadata: myArray })
                        this.isUserInteraction = false;
                        this.forceUpdate();
                    }
                    else{
                        this.setState({ algoliadata: [] })
                        this.getNoResultProperties();
                    }

                    /* ========= Local Cache =========== */
                    this.setState({
                        local_cache: [...this.state.local_cache, {[path_name]: myArray}]
                        }, () => localStorage.setItem('algolia_data', JSON.stringify(this.state.local_cache))
                    )
                    


                    // setTimeout(() => {
                    //     window.scrollTo(0, 0)
                    // }, 1000)

                });
            }
        }
    }

    /* ========= Local Cache =========== */
    filterLocalCache = (path_name) => {
        let get_local_cache = this.state.local_cache;
        let filter_local_cache = [];
        // filter_local_cache = get_local_cache.length > 0 && get_local_cache.filter(key => key[path_name]);

        if(get_local_cache?.length > 0){
            let remove_local_cache =  get_local_cache?.filter(key => Object.values(key)[0]?.expTime > (new Date().getTime()))

            this.setState({
                local_cache: remove_local_cache
                }, () => localStorage.setItem('algolia_data', JSON.stringify(remove_local_cache))
            )

            filter_local_cache = remove_local_cache?.length > 0 && remove_local_cache?.filter(key => key[path_name]);
        }

        //console.log("algoliadata 2", path_name, this.state.local_cache, filter_local_cache)

        return filter_local_cache;
    }

    getNoResultProperties = () => {
        var status_filter = "For Sale"

        if(this.props.search_type === "lettings"){
            status_filter = "To Let"
        }

        ApiRequest({
            method: "GET",
            url: `${process.env.GATSBY_STRAPI_SRC}/properties?search_type=${this.props.search_type}&_limit=6&_sort=published_at:DESC&publish=true&department=${this.props.department}&status=${status_filter}`,
            headers: {
                Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
            }
            
        }, (result) => {
            if (result.length > 0) {
                this.setState({ noResultProperties: result })
            }
        })
    }
    

     render() {
         const { searchState, noResultProperties, includes, my_page_url_data } = this.state;
         const searchParams = propertySearchParams({ ...this.props, my_page_url_data })

          const intro = propertyIntro(searchParams);
          const metaIntro = propertyIntro({ ...searchParams, introCopy: true });
          const metaTitle = propertyIntro({ ...searchParams, introCopy: false, isMetaTitle: true })

        let meta_data = {title: metaIntro ? toCapitalize(metaIntro) : this.props.title, description: metaIntro ? toCapitalize(metaIntro) : this.props.title}

         const { areas, propertyType, action, minPrice, maxPrice, bedrooms } = searchParams;

        var department = this.props.department;
        var search_type = this.props.search_type;
        var status = this.state.status; 

        let class_name = this.state.isGridView ? "search-header grid-view" : "search-header";

         var default_sort = sortByList.length > 0 ? Sortindex[(sortByList[0].value).toLowerCase()] : Sortindex["HighestPrice"]

         let pathname = `${search_type === "sales" ? "property_for_sale" : search_type === "lettings" ? "property_to_rent" : ""}`;

         //console.log("searchParams==>", searchParams)

         //console.log("algoliadata 3", this.state.local_cache, typeof window !== 'undefined' &&  localStorage.getItem('algolia_data') ? JSON.parse(localStorage.getItem('algolia_data')) : [])


        return (

            <div className={`${class_name} ${this.state.isGridView} search_result`} >
                <Layout seo_meta={meta_data} isJourneySec={true} dynamicSEO={true} stickyHeader={false} searchParams={searchParams} menu_slug="search_result">

                    <SeoResult searchParams={searchParams} />
                    <div>
                        {/* <Configure
                            hitsPerPage={20} 
                            page={0}
                            filters={`publish:true AND search_type:${search_type} AND department:${department} AND ${mystatus}`} 
                        /> */}
                        
                        {/* =========== Search Filter ========= */}
                        {searchParams?.areas && 
                            <Filter 
                                areas={areas}
                                department={department} 
                                search_type={search_type} 
                                status={status} 
                                searchState={searchParams}
                                onSaleAgreed={this.onSaleAgreed}
                                location={this.props?.location}
                                collections_property={this.props?.location?.state?.collections_property || this.props?.collections_property}
                                student_property={this.props?.location?.state?.student_property || this.props?.student_property}
                            />
                        }

                        <section className="grid-wrapper">

                            <div className="left_side">

                                {/* =========== H1 and Sortby Section ========= */}
                                <PropertyInfo algoliadata={this.state.algoliadata} onViewChange={this.onViewChange} metaIntro={metaIntro} intro={intro} location={this.props.location} searchState={searchParams} searchParams={searchParams} userObjects={this.props.userObjects} sortByList={sortByList} search_type={this.props.search_type} showPPPW={this.showPPPW} includeBills={this.includeBills} show_pppw={this.state?.show_pppw} />

                                {/* ========== Property List and Grid Section ======= */}
                                <SalesCard algoliadata={this.state.algoliadata} location_path={this.props?.location?.pathname} page_url_data={this.state.my_page_url_data} userObjects={this.props.userObjects} isGridView={this.state.isGridView} search_type={this.props.search_type} no_properties={noResultProperties} window_wdth = {this.state.width} collections_property={this.props?.location?.state?.collections_property || this.props?.collections_property}
                                student_property={this.props?.location?.state?.student_property || this.props?.student_property}
                                location_state={this.props?.location?.state}
                                show_pppw={this.state?.show_pppw}
                                />

                            </div>

                            <div className={`map-section `}>

                            {
                                (this.state.width > 1200 ? (
                                     this.state.isGridView && 
                                        <MapResultsDesktop algoliadata={this.state.algoliadata} srch_depart={this.state.srch_department} status={this.props.status} department={this.props.department} ptype={this.props.search_type === "sales" && this.props.department === "residential" ? "myResSaleProp" : this.props.search_type === "lettings" && this.props.department === "residential" ? "myResRentProp" : ''} noResultProperties={noResultProperties} />
                                    )
                                
                                :
                                <>
                                    <MapResultsMobile hits={this.state.algoliadata?.hits} noResultProperties={noResultProperties} srch_depart={this.state.srch_department}  ptype={this.props.search_type === "sales" && this.props.department === "residential" ? "myResSaleProp" : this.props.search_type === "lettings" && this.props.department === "residential" ? "myResRentProp" : ''}
                                    />
                                </>                                
                                )
                            }
                            </div>                       
                        </section>

                        
                    </div>
                    <Journey/>
                </Layout>
            </div>

        );
    }
}

export default SearchResultTemplate
